import React from "react";
import PropTypes from "prop-types";
import { Alert, Box, Button, Chip, Typography } from "@mui/material";
import CycleDialog, { CycleFields } from "./CycleDialog";
import { cycleDate, cycleCreatedAt } from "../model/cycleModel";

export default function CycleDetailDialog({ cycle, onClose }) {
  const result = cycle?.result;
  return (
    <CycleDialog
      open={Boolean(cycle)}
      onClose={onClose}
      title={`Intento de creación #${cycle?.id ?? ""}`}
      subtitle="Detalle de la solicitud y respuesta del servicio"
      actions={
        <Button variant="outlined" onClick={onClose}>
          Cerrar detalle
        </Button>
      }
    >
      {cycle && (
        <>
          <Alert
            severity={result.severity}
            sx={{
              borderRadius: 2,
              alignItems: "flex-start",
              "& .MuiAlert-message": { width: "100%", minWidth: 0 },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
              <Typography sx={{ fontSize: "1rem", fontWeight: 700, color: "inherit" }}>
                {result.label}
              </Typography>
              {result.code !== null && (
                <Chip
                  size="small"
                  label={`Código ${result.code}`}
                  sx={{ bgcolor: "rgba(255,255,255,.65)", color: "inherit", fontWeight: 700 }}
                />
              )}
            </Box>
            <Typography
              sx={{ fontSize: ".82rem", mt: 0.75, overflowWrap: "anywhere", color: "inherit" }}
            >
              {result.message}
            </Typography>
          </Alert>
          <CycleFields
            title="DATOS DEL INGRESO"
            fields={[
              ["Comercio", cycle.metadata?.commerce],
              ["Placa", cycle.metadata?.plate],
              ["Fecha de ingreso · Bogotá", cycleDate(cycle.metadata?.entry)],
              ["Registro de la solicitud · Colombia", cycleCreatedAt(cycle.createdAt)],
            ]}
          />
          <CycleFields
            title="ORIGEN DE LA SOLICITUD"
            fields={[
              ["ID del usuario", cycle.metadata?.userId ?? cycle.user_id],
              ["Dirección IP", cycle.ip],
              ["Controlador", cycle.payload?.ControllerId],
              ["Número de reader", cycle.payload?.ReaderNumber],
            ]}
          />
          <Box
            component="details"
            sx={{
              border: "1px solid #dce5ed",
              borderRadius: 2,
              bgcolor: "#fff",
              overflow: "hidden",
            }}
          >
            <Typography
              component="summary"
              sx={{
                cursor: "pointer",
                px: 2.5,
                py: 1.75,
                color: "#526579",
                fontWeight: 600,
                fontSize: ".78rem",
              }}
            >
              Datos técnicos originales
            </Typography>
            <Box
              component="pre"
              sx={{
                m: 0,
                px: 2.5,
                pb: 2,
                pt: 1,
                fontSize: ".72rem",
                color: "#334e68",
                bgcolor: "#f8fafc",
                overflow: "auto",
                maxHeight: 240,
              }}
            >
              {JSON.stringify({ ...cycle, result: undefined }, null, 2)}
            </Box>
          </Box>
        </>
      )}
    </CycleDialog>
  );
}
CycleDetailDialog.propTypes = { cycle: PropTypes.object, onClose: PropTypes.func.isRequired };
CycleDetailDialog.defaultProps = { cycle: null };
